import {Subsidiary} from './subsidiary';

export class SubsidiaryCollection {
    private totalItems: number = 0;
    private subsidiaries: Subsidiary[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setSubsidiaries(subsidiaries: Subsidiary[]) {
        this.subsidiaries = subsidiaries;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getSubsidiaries(): Subsidiary[] {
        return this.subsidiaries;
    }
}
